'use client';
import { useIntl } from 'react-intl';
import { IntlShape } from '@formatjs/intl';
import { footerLinks } from '../../../constants/footer';
import Columns from './Columns';

/**
 * Client footer columns.
 */
export const ClientFooterColumns = () => {
  const intl = useIntl() as IntlShape;

  return <Columns columns={footerLinks(intl).columns} />;
};

export default ClientFooterColumns;
